<template>
    <div class="card">
        <h6>Search Criteria:</h6>
        <Accordion>
            <AccordionTab header="Use as few or as many as you wish, partial matches are acceptable.">
                <div class="p-fluid formgrid grid">
                    <div class="field col-6 md:col-3">
                        <base-text-input v-model="taskCriteria.title" label="Title" />
                    </div>
                    <div class="field col-6 md:col-3">
                        <base-text-input v-model="taskCriteria.description" label="Description" />
                    </div>
                    <!-- Progress == Status -->
                    <div class="field col-6 md:col-3">
                        <base-multi-select v-model="taskCriteria.status" label="Status" :options="progressOptions" optionLabel="name" optionValue="id" :squaredChips="true" :filter="false" />
                    </div>
                    <div class="field col-6 md:col-3">
                        <base-multi-select v-model="taskCriteria.priority" label="Priority" :options="priorityOptions" optionLabel="name" optionValue="id" :squaredChips="true" :filter="false" />
                    </div>
                    <div class="field col-6 md:col-3">
                        <custom-vue-tree-select :key="treeSelectKey" v-model="taskCriteria.source_id" label="Source" :optionsTree="sourceVueTree" :showLabel="true" :valueConsist="'ALL'" :multiple="true" :limit="2" />
                    </div>
                    <div class="field col-6 md:col-3">
                        <base-number-input v-model="taskCriteria.incident_number" label="Incident" />
                    </div>
                    <div class="field col-6 md:col-3">
                        <custom-vue-tree-select :key="treeSelectKey" v-model="taskCriteria.from_department_id" label="Department From" :optionsTree="departmentVueTree" :showLabel="true" :valueConsist="'ALL'" :multiple="true" :limit="2" />
                    </div>
                    <div class="field col-6 md:col-3">
                        <custom-vue-tree-select :key="treeSelectKey" v-model="taskCriteria.to_department_id" label="Department To" :optionsTree="departmentVueTree" :showLabel="true" :valueConsist="'ALL'" :multiple="true" :limit="2" />
                    </div>
                    <div class="field col-6 md:col-3">
                        <base-calendar-input v-model="taskCriteria.start_date_from" label="Start Date From" dateFormat="dd-mm-yy" />
                    </div>
                    <div class="field col-6 md:col-3">
                        <base-calendar-input v-model="taskCriteria.start_date_to" label="Start Date To" dateFormat="dd-mm-yy" />
                    </div>
                    <div class="field col-6 md:col-3">
                        <base-calendar-input v-model="taskCriteria.due_date_from" label="Due Date From" dateFormat="dd-mm-yy" />
                    </div>
                    <div class="field col-6 md:col-3">
                        <base-calendar-input v-model="taskCriteria.due_date_to" label="Due Date To" dateFormat="dd-mm-yy" />
                    </div>
                    <div class="field col-6 md:col-3">
                        <custom-vue-tree-select :key="treeSelectKey" v-model="taskCriteria.theme_id" label="Theme" :optionsTree="themeVueTree" :showLabel="true" :valueConsist="'ALL'" :multiple="true" :limit="3" />
                    </div>
                    <div class="field col-6 md:col-3">
                        <UsersSelectionPanel v-model="taskCriteria.assigned_to_id"> Assigned To: </UsersSelectionPanel>
                    </div>
                    <div class="field col-6 md:col-3">
                        <base-selection-input v-model="taskCriteria.overdue" :label="`Overdue ${label('Tasks')}`" :radio-type="true" :options="getOverdDueTasks()" />
                    </div>
                    <div class="mt-4 formgrid grid col-8">
                        <div class="field col-6 md:col-3">
                            <Button type="button" label="Search" icon="pi pi-search" @click="applyFilters" />
                        </div>
                        <div class="field col-6 md:col-3">
                            <Button type="button" label="Clear" icon="pi pi-trash" @click="clearCriteria" />
                        </div>
                    </div>
                </div>
            </AccordionTab>
        </Accordion>
    </div>
</template>
<script setup>
import UsersSelectionPanel from '@/modules/user/components/UsersSelectionPanel';

/*
Please note:
The component VueTreeSelect is not able to react to v-model changes: if it changes no internal changes are fired.
Change the :key to force Vue to consider it a new component.
E.g.
<custom-vue-tree-select :key="my_key" v-model="my_model" [...] />

In this case, is treeSelectKey updated by clearCriteria()
 */

import { storeToRefs } from 'pinia';
import { ref, onMounted } from 'vue';
import { departmentStore, reportStore, sourceStore, themeStore } from '@/store/global-stores';
import { getAllPriorities, getAllProgress } from '../../../constants';
import { showToast } from '@/utilities/toast-handler';
import { getOverdDueTasks } from '@/product/ams/modules/task/constants';
import { useLabels } from '@/composables/LabelComposable';

const { taskCriteria } = storeToRefs(reportStore);
const { sourceVueTree } = storeToRefs(sourceStore);
const { themeVueTree } = storeToRefs(themeStore);
const { departmentVueTree } = storeToRefs(departmentStore);

const progressOptions = ref(null);
const priorityOptions = ref(null);
const taskLoading = ref(false);
const { params } = storeToRefs(reportStore);
const { label } = useLabels();

const treeSelectKey = ref(0);

onMounted(async () => {
    await loadTaskReport();
    await loadServices();
    loadOptions();
});

const loadServices = async () => {
    await sourceStore.fetchAllSources();
    await themeStore.fetchAllThemes();
    await departmentStore.fetchAllDepartments();
};

const loadOptions = () => {
    progressOptions.value = getAllProgress();
    priorityOptions.value = getAllPriorities();
};

function applyFilters() {
    params.value.page = 0
    console.log('params.value.page', params.value.page)
    loadTaskReport()
}

const loadTaskReport = async () => {
    taskLoading.value = true;
    await reportStore.getDynamicTaskReport();
    taskLoading.value = false;
};

const clearCriteria = () => {
    treeSelectKey.value++
    reportStore.initTaskCriteria();
    showToast({ severity: 'info', summary: 'Filters Cleared' }, 'All Criteria filters have been cleared');
};
</script>
